__turbopack_context__.v({
  "load": "loadingState-module-scss-module__Wce4Ra__load",
});
